// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"ZS-z"};